import type { ReactNode } from "react";
import { Lockup } from "./Lockup";

/**
 * The branded frame the **chromeless** states render inside — loading, signed out, and the
 * config error. A card is centred in the viewport and carries the full lockup, because in
 * those states the lockup is the only thing on screen saying what this is.
 *
 * Everything a signed-in member sees is the shell (`Frame`) instead, which fills the page.
 */
export function Card({ children }: { children: ReactNode }) {
  return (
    <main className="card">
      <Lockup />
      {children}
    </main>
  );
}
